import { render, staticRenderFns } from "./histogramGdhCourse.vue?vue&type=template&id=a4d787ca&scoped=true"
import script from "./histogramGdhCourse.vue?vue&type=script&lang=js"
export * from "./histogramGdhCourse.vue?vue&type=script&lang=js"
import style0 from "./histogramGdhCourse.vue?vue&type=style&index=0&id=a4d787ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d787ca",
  null
  
)

export default component.exports